const cadenceNounByUnit: Record<string, string> = {
    Daily: "day",
    Weekly: "week",
    Monthly: "month",
};

export const describeCadence = (intervalCount: number, intervalUnit: string): string => {
    const noun = cadenceNounByUnit[intervalUnit] ?? intervalUnit.toLowerCase();
    return intervalCount === 1 ? `every ${noun}` : `every ${intervalCount} ${noun}s`;
};

const channelLabelByKind: Record<string, string> = {
    email: "Email",
    call: "Call",
    text: "Text",
    visit: "Visit",
};

const loggedChannelLabelByKind: Record<string, string> = {
    email: "Email",
    call: "Call",
    text: "Text",
    visit: "In person",
};

export const channelLabel = (kind: string): string =>
    loggedChannelLabelByKind[kind] ?? kind;

export const describeChannels = (kinds: string[]): string => {
    const labels = kinds.map(kind => channelLabelByKind[kind] ?? kind);
    if (labels.length <= 1) {
        return labels[0] ?? "";
    }
    return `${labels.slice(0, -1).join(", ")} or ${labels[labels.length - 1]}`;
};

export const scheduledVisitLabel = "Scheduled a Visit";
